((VideoPlayer) => {
  'use strict';

  const dom = {};

  const cacheDom = () => {
    dom.videoPlayer = document.querySelector('[data-video-player]');
    dom.videoPoster = document.querySelector('[data-video-poster]');
  }

  const initVideo = () => {
    // no need for JS if there is no embed / no poster
    if(!dom.videoPlayer || !dom.videoPoster) return;

    // setup script to allow poster click to control video
    const vimeoSDK = document.createElement('script');
    vimeoSDK.setAttribute('src', 'https://player.vimeo.com/api/player.js');
    document.head.appendChild(vimeoSDK);

    // wait for vimeo SDK script
    vimeoSDK.addEventListener('load', () => {
      const event = new Event(`VimeoLoaded`);
      window.dispatchEvent(event);
      setupVimeo();
    })
  }

  const setupVimeo = () => {
    const iframe = document.querySelector('[data-video-player] iframe');
    const player = new Vimeo.Player(iframe);

    // hide poster + play video
    dom.videoPoster.addEventListener('click', () => {
      dom.videoPoster.style.opacity = 0;
      setTimeout(() => {
        dom.videoPoster.style.display = 'none';
      }, 800);
      player.play();
    });

    // show poster and reset video
    player.on('ended', data => {
      dom.videoPoster.style.display = 'flex';
      dom.videoPoster.style.opacity = 1;
      player.setCurrentTime(0);
    });
  }

  const init = () => { 
    cacheDom();
    initVideo();
  };

  VideoPlayer.init = init;
})(window.VideoPlayer = window.VideoPlayer || {});